import { UserProfile } from 'fitbeat.gym-core';
import React, { FunctionComponent } from 'react';
import { translate } from 'react-i18next';
import { Platform, SafeAreaView, StyleSheet, Text, View } from 'react-native';
import FitillionLogo from '../../assets/images/fitllion-horizontal-logo-gym-smart.svg';
import homeHeaderImage from '../../assets/images/header-images/home-workout-knee-to-elbow.jpg';
import headerImage from '../../assets/images/header-images/studio-header.jpg';
import { Button } from '../../components';
import { GymResolver } from '../../services/GymResolver';
import Theme from '../../theme';
import { TrackingImageTile } from '../../Tracking/components/TrackingImageTile';
import { defaultScale, scaleImageAspectRatio } from '../../utils';
import { openMembershipPlans } from '../utils';

interface IProps {
  userProfile: UserProfile;
  hasAccessToAStudio: boolean;
  t: (key: string, options?: any) => string;
}

const NoPlanIdForStudioSubscriptionPaywall: FunctionComponent<IProps> = (
  {
    userProfile,
    t,
    hasAccessToAStudio,
  },
) => {
  return (
    !hasAccessToAStudio ?
    (<View style={styles.container}>
      <TrackingImageTile
        imageSource={homeHeaderImage}
        containerStyle={[styles.headerImageContainer, {aspectRatio: scaleImageAspectRatio(0.8)}]}
        actions={<></>}
      />
      <SafeAreaView style={styles.contentContainer}>
        <View style={styles.textContainer}>
          <Text style={[Theme.textStyle.headingLarge, { marginBottom: defaultScale(15) }]}>
            {t('yourMembershipHasExpired')}
          </Text>
          {(userProfile.gymName) &&(
            <Text style={Theme.textStyle.bodyCopyReg}>
              {t('GymActivationSubHeading', {
                gymPersonalisedHeader: GymResolver.getPersonalisedHeaderOrDisplayName(userProfile.gymName),
              })}
            </Text>)
          }
        </View>
        <View>
          <Button
            fontColor={Theme.WHITE}
            title={t('auth:seeMembershipPlans')}
            onPress={() => openMembershipPlans(userProfile)}
            containerStyle={{ marginBottom: defaultScale(10) }}
          />
        </View>
      </SafeAreaView>
    </View>)
 :
    (<View style={styles.container}>
      <TrackingImageTile
        imageSource={headerImage}
        containerStyle={styles.headerImageContainer}
        actions={<></>}
      />
      <SafeAreaView style={styles.contentContainer}>
        <View style={{ flex: 1, justifyContent: 'center' }}>
          <FitillionLogo height={defaultScale(70)} fill={Theme.BLACK}/>
        </View>
        <View style={styles.textContainer}>
          <Text style={[Theme.textStyle.headingLarge, { marginBottom: defaultScale(15) }]}>
            {t('activateYourFitillionMembership')}
          </Text>
          <Text style={Theme.textStyle.bodyCopyReg}>{t('toActivateSelectPlan')}</Text>
        </View>
        <View>
          <Button
            fontColor={Theme.WHITE}
            title={t('auth:seeMembershipPlans')}
            onPress={() => openMembershipPlans(userProfile)}
            containerStyle={{ marginBottom: defaultScale(10) }}
          />
        </View>
      </SafeAreaView>
    </View>)
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: Theme.WHITE,
    height: '100%',
    flex: 1,
  },
  contentContainer: {
    margin: defaultScale(15),
    flex: 1,
  },
  headerImageContainer: {
    ...Platform.select({
      web: {
        height: '50%',
      },
      default: {
        height: undefined,
      },
    }),
    width: '100%',
    aspectRatio: scaleImageAspectRatio(1),
  },
  textContainer: {
    paddingBottom: defaultScale(20),
  },
});

export default translate(['payments', 'auth'], { wait: true })(NoPlanIdForStudioSubscriptionPaywall);
